import { useMemo } from "react";
import { useTranslations } from "use-intl";

// Generates a stable per-render error ID for support tracing.
// Format: err_<8 hex chars> — short enough to copy, unique enough for log correlation.
function generateErrorId(): string {
  const bytes = new Uint8Array(4);
  crypto.getRandomValues(bytes);
  const hex = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return `err_${hex}`;
}

export function ErrorId() {
  const t = useTranslations();
  // Stable for the lifetime of this error page render — not regenerated on re-renders.
  const id = useMemo(() => generateErrorId(), []);
  const timestamp = useMemo(() => new Date().toISOString().replace("T", " ").slice(0, 19), []);

  return (
    <p className="text-center text-xs text-[var(--muted-foreground)]">
      {t("errors.common.error_id_label")}:{" "}
      <code className="font-mono font-medium text-[var(--foreground)]">{id}</code>
      {" · "}
      {timestamp}
    </p>
  );
}
